
import './formInput.css';
import {useState} from 'react';

function FormInput({label, itemInput, setItemInput, auth, isPassword, inactive, istype='text', muted }) {

    const changeHandler = (e) => {
        setItemInput(e.target.value);
    }
    
    const [eye, setEye] = useState(true);

    return (
        <div className={['formInput', inactive ? 'inactive' : ''].join(' ')} style={auth ? {width: '100%'} :{width: '160px'}}>
            {
                isPassword ? (
                    <input type={eye ? "password" : "text"} onChange={changeHandler} value={itemInput} className={itemInput.trim()!="" ? 'has-value' : ''}/>
                ) : (
                    muted ? (
                        <input type={istype} onChange={changeHandler} value={itemInput} className={'has-value'}/>
                    ) : (
                        <input type={istype} onChange={changeHandler} value={itemInput} className={itemInput.trim()!="" ? 'has-value' : ''}/>
                    )
                )
            }
            <label>{label}</label>
            {
                isPassword && (
                    <i className={`fa-solid fa-eye${eye === true ? "-slash" : ""}`} onClick={()=>setEye(prev=>!prev)}></i>
                )
            }
        </div>
    )
}
export default FormInput